import Vue from 'vue';

const state = {
  following: {},
};

const getters = {
  'get-following-user': (state) => (slug) => state.following[slug],
};

const actions = {
  updateFollowing({ commit }, following) {
    commit('setFollowing', following);
  },
};

const mutations = {
  setFollowing(state, payload) {
    Vue.set(state.following, payload.slug, { isFollowing: payload.isFollowing, isProcessing: payload.isProcessing });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
